import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Delete from "./Delete.js"
import Detail from "./Detail.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"



class SubTipos extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Tipo",
                    id: "tipo__nombre",
                    accessor: d => d.tipo__nombre,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create:true,
                        permission: 'tiposdeplan_add',
                        component: Create,
                    },
                    {
                        edit:true,
                        permission: 'tiposdeplan_edit',
                        component: Edit,
                    },
                    {
                        detail: true,
                        permission: 'tiposdeplan_detail',
                        component: Detail,
                    },
                    {
                        edit:true,
                        permission: 'tiposdeplan_delete',
                        component: Delete,
                    }
                ]}

                apiUrl={api.proyectos.config.plan.subtipos.list}
                columns={this.state.columns}
                exportUrl={api.proyectos.config.plan.subtipos.export}
                title={"Subtipos de Transferencia"}
                outerSort={[{"id":"nombre","desc":false}]}
            />
        );
    }
}

export default SubTipos;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Plan_SubTipos/SubTipos.js